import { Resources } from 'constants/resources';

import { useFormContext, useWatch } from 'react-hook-form';
import { AutocompleteInputSynced, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { cleanEmpty } from 'utils/cleanEmpty';

import { OrderManualCreateSection } from './OrderManualCreateSection';

export const MERCHANT_DEPENDENTS = [
  'merchantAccount',
  'merchantAccountName',
  'provider',
  'providerName',
  'gateway',
  'gatewayName',
  'method',
  'methodName',
];

export const OrderManualCreateMerchantFields = () => {
  const { resetField } = useFormContext();
  const merchant = useWatch({ name: 'merchant' });

  return (
    <OrderManualCreateSection title="Данные мерчанта">
      <ReferenceInput perPage={100} reference={Resources.Merchants} source="merchant">
        <AutocompleteInputSynced
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Мерчант"
          onChange={() => MERCHANT_DEPENDENTS.forEach((field) => resetField(field))}
          optionText="name"
          syncFields={{ merchantName: 'name' }}
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput
        filter={cleanEmpty({ merchant })}
        perPage={100}
        reference={Resources.MerchantAccounts}
        source="merchantAccount"
      >
        <AutocompleteInputSynced
          disabled={!merchant}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Счет мерчанта"
          optionText="name"
          syncFields={{ merchantAccountName: 'name' }}
          variant="outlined"
        />
      </ReferenceInput>
      <TextInput
        helperText={false}
        isRequired
        label="Клиент"
        source="customerId"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        isRequired
        label="Данные клиента"
        source="customerAccount"
        variant="outlined"
      />
    </OrderManualCreateSection>
  );
};
